import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-white font-sans antialiased text-slate-900">
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/produkter" element={<ProductsPage />} />
          <Route path="/projekter" element={<ProjectsPage />} />
          <Route path="/projekter/:slug" element={<ProjectDetailPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
        </Routes>
        
        <Footer />
      </div>
    </>
  );
}

export default App;
